import { useContext, useEffect, useState } from "react";
import "./DarshanTemple.css";
import { FaqModuleID, ServiceDiscounts } from "../enum";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import { customSelectStyles, SelectIdProof, SelectLanguageOptions } from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
import CODModal from "../../Pages/PanditBooking/CODModal";
import axios from "axios";
import { Tooltip } from "@mui/material";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  RazorPayKey,
  RazorPayName,
  RazorPaySecretKey,
} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../../Pages/Stepper Form/stepper.css";
import TempleCodModal from "./TempleCodModal";
import { DarshanBook_TempleListGETTimeSlot } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";
const steps = [
  "Booking Details",
  // "Show Details",
  "Booking Preview",
  "Payment Status",
];

const TempleBookingForm = () => {
  const [selectedIdProof, setSelectedIdProof] = useState("Aadhaar Card");
  const [currentStep, setCurrentStep] = useState(0);
  const [showCODModal, setShowCODModal] = useState(null);
  const [selectedPandit, setSelectedPandit] = useState(null);
  const [orderID, setOrderID] = useState();
  const [panditSelectionError, setPanditSelectionError] = useState(null);
  const [error, setError] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(null);
  const [showBookingReviewModal, setShowBookingReviewModal] = useState(null);
  const [panditDataList, setPanditDataList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [timeSlotOption, setTimeSlotOption] = useState([]);
  const [timeSlotMap, setTimeSlotMap] = useState({});
  const [totals, setTotals] = useState({
    totalPrice: 0,
    totalConvienceFee: 0,
    GrandTotal: 0,
  });
  const [members, setMembers] = useState([]);
  const [showMembers, setShowMembers] = useState(false);
  const { setLoader, loader, activeCategory, setActiveCategory } =
    useContext(LoaderContext);
  const [templeBookingObj, setTempleBookingObj] = useState({
    time: null,
    languageID: null,
    landmark: null,
    address: null,
    pincode: null,
    ID_PROOF: "Aadhaar Card",
    needSamagri: null,
    TR_ID: null,
    NO_SEATS: null,
    TRB_PRICE: null,
    TRB_TOTALPRICE: null,
    REFERAN_CODE: null,
    ID_PROOF_NO: null,
    TRB_DATE: null,
    TTS_ID: null,
    PAYMENT_TYPE: null,
    TRANSACTION_ID: null,
    PAYMENT_STATUS: null,
    USER_ID: null,
    CONVINIENCE_FEE: null,
    TAX: null,
    EXTRA: null,
    ID_PROOF_PIC: null,
    AGE: null,
    BookingPersonDetails: [],
    GENDERID: null,
    contactNumber: null,
    personName: null
  });
  const [modelRequestData, setModelRequestData] = useState({
    totalPrice: null,
    amountEntered: null,
    convenienceFeeAddedWithTax: null,
    moduleName: null,
    couponCode: null
  });

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const [isWalletApplied, setIsWalletApplied] = useState(false);

  const fromDate = dayjs();

  const userID = localStorage.getItem("userID");
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(9000)

  const product = location.state?.product;
  const langID = location.state?.langID;
  const pujaDetails = location.state;
  // console.log("templeBookingObj", templeBookingObj);
  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: FaqModuleID?.DarshanBooking,
    subModuleID: [location?.state?.TR_ID],
    orderAmount: Math.round(totals?.totalPrice)

  })
  useEffect(() => {

    if (currentStep === 1) {
      setTotals((prev) => ({
        ...prev,
        totalPrice: Math.round(
          Number(templeBookingObj?.NO_SEATS) *
          Number(location?.state?.DARSHAN_PRICE)
        ),
        totalConvienceFee: Math.round(
          Number(location?.state?.CONVENIENCE_FEE) +
          Number(location?.state?.ConvinienceFeeTaxAmount)
        ),
      }));
      setCouponObj((prev) => ({
        ...prev, orderAmount: Math.round(
          Number(templeBookingObj?.NO_SEATS) *
          Number(location?.state?.DARSHAN_PRICE)
        )
      }))
    }
  }, [currentStep]);
  console.log('amount', couponObj)

  const [razorPayData, setRazorPayData] = useState({
    PB_DATE: null,
    PB_TIME: null,
    PB_LANGAUGE: null,
    PB_SAMAGRI: null,
    PB_PRICE: null,
    PB_SAMAGRIPRICE: null,
    PANDIT_ID: null,
    USER_ID: null,
    REFERENCES_NO: "",
    ADDRESS: null,
    PUJA_ID: null,
    PAYMENT_TYPE: null,
    CONVINIENCE_FEE: null,
    TAX: null,
    EXTRA: null,
    TRANSACTION_ID: "",
    TRANSACTION_AMT: "",
  });

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setAppliedCoupon((prev) => ({
        ...prev, CouponCode: null,
        isApplied: false,
        CoupenAmount: 0,
        walletAmount: 0
      }))
      setIsWalletApplied(false)
      setCurrentStep(currentStep - 1);

    }
  };

  useEffect(() => {
    GetPanditListData();
    GetUserWalletAmountData()
  }, []);
  useEffect(() => {
    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(Number(totals?.totalPrice), walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);

      if (appliedCoupon?.walletAmount !== discountAmount) {
        setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }));
        setCouponAmount(discountAmount);
      }

    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount);

    } else if (isWalletApplied === false && appliedCoupon?.isApplied === false) {
      setCouponAmount(0);

      if (appliedCoupon?.walletAmount !== 0) {
        setAppliedCoupon((prev) => ({ ...prev, walletAmount: 0 }));
      }
    }
  }, [isWalletApplied, appliedCoupon, totals?.totalPrice, walletAmount]);


  const handleGenderChange = (selectedOption) => {
    // handleMemberChange(
    //   0,
    //   "Gender",
    //   selectedOption ? selectedOption.value : null
    // )
    setTempleBookingObj((prev) => {
      const updatedBookingDetails = [...prev.BookingPersonDetails];

      if (updatedBookingDetails.length > 0) {
        updatedBookingDetails[0] = {
          ...updatedBookingDetails[0],
          Gender: selectedOption ? selectedOption.value : null, // 👈 update only Name
        };
      }

      return {
        ...prev,
        GENDERID: selectedOption ? selectedOption.value : null,
        BookingPersonDetails: updatedBookingDetails,
      };
    });


  };

  const SGST = 9;
  const CGST = 9;
  const convenienceFee = parseFloat(location?.state?.CONVENIENCE_FEE) || 0; // Ensure it's a number
  // const DynamicTax = ((SGST + CGST) / 100) * convenienceFee; // Tax Calculation

  // useEffect(() => {
  //   setRazorPayData((prev) => ({
  //     ...prev,
  //     PB_DATE: templeBookingObj.date,
  //     PB_TIME: templeBookingObj.time,
  //     PB_LANGAUGE: SelectLanguageOptions.find(
  //       (item) => item.value === templeBookingObj.languageID
  //     )?.label,
  //     PB_SAMAGRI: templeBookingObj.needSamagri,
  //     PB_PRICE: pujaDetails?.pujaPrice,
  //     PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
  //     PANDIT_ID: selectedPandit,
  //     USER_ID: userID,
  //     REFERENCES_NO: "",
  //     ADDRESS: templeBookingObj?.address,
  //     PUJA_ID: pujaDetails?.pujaId,
  //     PAYMENT_TYPE: "ONLINE",
  //     CONVINIENCE_FEE: pujaDetails?.convenienceFee,
  //     TAX: null,
  //     EXTRA: null,
  //     TRANSACTION_ID: "",
  //     TRANSACTION_AMT: "",
  //   }));
  // }, []);

  // Calculate Total Price
  // const totalPrice1 =
  //   Number(templeBookingObj.NO_SEATS) * Number(location.state.DARSHAN_PRICE) +
  //   Number(location.state.CONVENIENCE_FEE) +
  //   DynamicTax;

  const totalBeforeTax = Math.round(
    Number(templeBookingObj.NO_SEATS) * Number(location.state.DARSHAN_PRICE) +
    Number(location?.state?.CONVENIENCE_FEE)
  );

  const DynamicTax = Math.ceil(
    (totalBeforeTax * Number(ServiceDiscounts?.DailyBookingDiscount)) / 100
  );

  // const totalPrice1 = totalBeforeTax + DynamicTax;
  const totalPrice1 = Math.round(
    (totals?.totalPrice + totals?.totalConvienceFee) - couponAmount

  );
  const convenienceFeeAddedWithTax = Math.round(
    Number(location.state.CONVENIENCE_FEE) +
    Number(location?.state?.ConvinienceFeeTaxAmount)
  );

  // const convenienceFeeAddedWithTax= DynamicTax + location.state.CONVENIENCE_FEE

  //   const GetPanditListData = () => {};
  const GetPanditListData = async () => {
    try {
      const response = await GetPanditListDataAPI(
        userID,
        location?.state?.product?.PUJA_ID,

        {
          START: 1,
          END: 10,
          WORD: "None",
          LATITUDE: "20.0086678",
          LONGITUDE: "73.7639264",
        }
      );

      if (response) {
        setPanditDataList(response.DATA);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const HandleTempleDarshanBookingBtnClicked = () => {

    let isValid = false;
    const numSeats = parseInt(templeBookingObj.NO_SEATS, 10);

    if (
      templeBookingObj.TRB_DATE === null ||
      templeBookingObj.TRB_DATE === undefined ||
      templeBookingObj.TRB_DATE === "" ||
      templeBookingObj.NO_SEATS <= 0 ||
      // templeBookingObj.NO_SEATS === undefined ||
      // templeBookingObj.NO_SEATS === "" ||
      templeBookingObj.AGE === null ||
      templeBookingObj.AGE === undefined ||
      templeBookingObj.AGE === "" ||
      templeBookingObj.ID_PROOF === null ||
      templeBookingObj.ID_PROOF === undefined ||
      templeBookingObj.ID_PROOF === "" ||
      templeBookingObj.ID_PROOF_NO === null ||
      templeBookingObj.ID_PROOF_NO === undefined ||
      templeBookingObj.ID_PROOF_NO === ""
    ) {
      isValid = true;
      setError(true);
    } else if ((templeBookingObj.contactNumber !== null && templeBookingObj.contactNumber !== undefined && templeBookingObj.contactNumber !== '') && templeBookingObj.contactNumber?.length !== 10) {
      isValid = true;
      setError(true);
    }
    // Validate each member's details
    // Validate number of seats is valid
    if (isNaN(numSeats) || numSeats < 0) {
      // Changed to < 0
      isValid = true;
      setError(true);
    }

    // Validate members if seats are required
    // Handle member validation based on seat count
    if (numSeats === 0) {
      // If seats are 0, ensure no members exist
      if (
        templeBookingObj.BookingPersonDetails &&
        templeBookingObj.BookingPersonDetails.length > 0
      ) {
        isValid = true;
        setError(true);
      }
    } else if (numSeats > 0) {
      // Validate members when seats are positive
      if (
        !templeBookingObj.BookingPersonDetails ||
        (Number(templeBookingObj.NO_SEATS) > 1 && templeBookingObj.BookingPersonDetails.length !== Number(templeBookingObj.NO_SEATS))
      ) {
        isValid = true;
        setError(true);
      }

      templeBookingObj.BookingPersonDetails?.forEach((member) => {
        if (
          member.Name === null ||
          member.Name === "" ||
          member.Name === undefined ||
          member.Age === null ||
          member.Age === undefined ||
          member.Age === "" ||
          member.Gender === "" ||
          member.Gender === null ||
          member.Gender === undefined
        ) {
          isValid = true;
          setError(true);
        }
      });
    }

    if (!isValid) {
      if (Number(templeBookingObj?.NO_SEATS) === 1) {
        setTempleBookingObj((prev) => ({
          ...prev,
          BookingPersonDetails: [
            ...prev.BookingPersonDetails,
            {
              Name: prev.personName || "",
              Age: prev.AGE || "",
              Gender: prev.GENDERID || ""
            }
          ]
        }));
      }


      nextStep();
      // alert(JSON.stringify(templeBookingObj))
    }
  };

  const handleRazorpayPayment = async () => {
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Number(totalPrice1);

    let orderIDReturned = null;
    const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)
    console.log('PlaceOrderResponse', PlaceOrderResponse)
    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/DarshanBook_Booking?TYPE`, {
          TR_ID: location?.state?.TR_ID,
          NO_SEATS: templeBookingObj.NO_SEATS,
          TRB_PRICE: location?.state?.DARSHAN_PRICE,
          TRB_TOTALPRICE: totalPrice1,
          REFERAN_CODE: "",
          AGE: templeBookingObj?.AGE,
          ID_PROOF: templeBookingObj?.ID_PROOF,
          TRB_DATE: templeBookingObj.TRB_DATE,
          USER_ID: userID,
          Tax_Perc: ServiceDiscounts?.darshanBooking,
          Tax_Amount: DynamicTax,
          PAYMENT_STATUS:
            minPayableAmount == totalPrice1 ? "Completed" : "Pending",

          TTS_ID: templeBookingObj?.TTS_ID,
          ADDRESS: templeBookingObj?.address,
          PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
          CONVINIENCE_FEE: location.state.CONVENIENCE_FEE,
          TAX: DynamicTax,
          // Tax_Amount: convenienceFeeAddedWithTax,
          EXTRA: null,

          TRANSACTION_STATUS: "Success",
          EXTRA: "",
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          TRANSACTION_AMT: minPayableAmount,
          ID_PROOF_PIC: "",
          ID_PROOF_NO: templeBookingObj.ID_PROOF_NO,
          BookingPersonDetails: templeBookingObj.BookingPersonDetails,
          CouponCodeID: appliedCoupon?.couponCodeID,
          CouponCodeAmount: appliedCoupon?.CoupenAmount,
          WalletAmount: appliedCoupon?.walletAmount,
        })
        .then((res) => {
          if (res) {

            console.log(res);
            setOrderID(res.data.ID);
            setShowCODModal(false);
            setLoader(false);

            // localStorage.setItem("orderID", JSON.stringify(res.data.ID));
            orderIDReturned = res.data.ID;
            navigate("/thank-you", {
              state: { moduleName: "DarshanBooking" },
            });
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };
  const handlePhonePayPayment = () => {
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Number(totalPrice1);

    const PhonePayOption = {
      UserID: userID,
      MobileNumber: "",
      ModalName: "templeBooking",
      Amount: minPayableAmount,
    };

    const templeBookingData = {
      TR_ID: location?.state?.TR_ID,
      NO_SEATS: templeBookingObj.NO_SEATS,
      TRB_PRICE: location?.state?.DARSHAN_PRICE,
      TRB_TOTALPRICE: totalPrice1,
      REFERAN_CODE: "",
      AGE: templeBookingObj?.AGE,
      ID_PROOF: templeBookingObj?.ID_PROOF,
      TRB_DATE: templeBookingObj.TRB_DATE,
      USER_ID: userID,
      Tax_Perc: ServiceDiscounts?.darshanBooking,
      Tax_Amount: DynamicTax,
      PAYMENT_STATUS: minPayableAmount == totalPrice ? "Completed" : "Pending",

      TTS_ID: templeBookingObj?.TTS_ID,
      ADDRESS: templeBookingObj?.address,
      PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
      CONVINIENCE_FEE: location?.state?.CONVENIENCE_FEE,
      TAX: DynamicTax,
      // Tax_Amount: convenienceFeeAddedWithTax,
      EXTRA: null,
      PAYMENT_STATUS: "",
      TRANSACTION_STATUS: "Success",
      EXTRA: "",
      // TRANSACTION_ID: paymentId,
      TRANSACTION_AMT: minPayableAmount,
      ID_PROOF_PIC: "",
      ID_PROOF_NO: templeBookingObj.ID_PROOF_NO,
      BookingPersonDetails: templeBookingObj.BookingPersonDetails,
    };

    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {
          console.log("PhonePe Response:", res.data);

          // Use navigate with state instead of window.location.href
          localStorage.setItem(
            "templeBookingData",
            JSON.stringify(templeBookingData)
          );

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };

  const handlePanditSelectionNext = () => {
    nextStep();
  };

  const handleToDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setTempleBookingObj((prev) => ({ ...prev, TRB_DATE: newToDate }));
    } else {
      setTempleBookingObj((prev) => ({ ...prev, TRB_DATE: null }));
    }
  };

  const handleIdProofChange = (selectedOption) => {
    setSelectedIdProof(selectedOption.value);
    setTempleBookingObj((prev) => ({
      ...prev,
      ID_PROOF: selectedOption.value,
    }));
  };

  const handlePanditCardClicked = (pandit) => {
    setSelectedPandit(pandit.PANDIT_ID);
    // console.log(pandit);
  };

  const handleCODClicked = () => {
    setModelRequestData((prev) => ({
      ...prev,
      convenienceFeeAddedWithTax: convenienceFeeAddedWithTax,
      totalPrice1: totalPrice1,
    }));
    setShowCODModal(true);
  };

  const totalPrice =
    parseFloat(product?.PUJA_PRICE || 0) +
    (templeBookingObj.needSamagri === "yes"
      ? parseFloat(product?.SAMAGRI_PRICE || 0)
      : 0) +
    parseFloat(product?.DAKSHINA || 0) +
    parseFloat(product?.CONVENIENCE_FEE || 0) +
    2 - //Tax amount
    parseFloat(product?.PUJA_DISC || 0); // Subtract discount if applicable

  console.log(product?.PUJA_PRICE);
  useEffect(() => {
    GetMyBookPanditCategoryData();
    GetUserWalletAmountData()
  }, []);

  const GetMyBookPanditCategoryData = async () => {
    try {
      const response = await DarshanBook_TempleListGETTimeSlot(
        location?.state?.TR_ID,
        userID
      );

      if (
        response.ResponseMessage === "list" &&
        response.ResponseCode === "0" &&
        Array.isArray(response.DATA)
      ) {
        // Transform the data into the format required by react-select
        const formattedOptions = response.DATA.map((slot) => ({
          value: slot.TTS_ID,
          label: slot.TTS_NAME,
        }));

        setTimeSlotOption(formattedOptions);
        // Create a mapping of IDs to names for easy lookup
        const idToNameMap = {};
        response.DATA.forEach((slot) => {
          idToNameMap[slot.TTS_ID] = slot.TTS_NAME;
        });
        setTimeSlotMap(idToNameMap);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getTimeSlotName = (id) => {
    return id ? timeSlotMap[id] || "Unknown slot" : "No slot selected";
  };

  const handleTimeSlotChange = (selectedOption) => {
    if (selectedOption) {
      setTempleBookingObj((prev) => ({
        ...prev,
        TTS_ID: selectedOption.value,
      }));
    } else {
      // Handle clearing of selection
      setTempleBookingObj((prev) => ({
        ...prev,
        TTS_ID: null,
      }));
    }
  };

  const handleAddMembers = (value) => {

    const numSeats = parseInt(templeBookingObj.NO_SEATS, 10);

    if (numSeats > 0) {
      const membersArray = Array.from({ length: numSeats - 1 }, () => ({
        Name: "",
        Age: "",
        Gender: null,
      }));

      setTempleBookingObj((prev) => ({
        ...prev,
        BookingPersonDetails: [
          {
            Name: prev.personName || "",
            Age: prev.AGE || "",
            Gender: prev.GENDERID || "",
          },
          ...membersArray, // ✅ spread to flatten the array
        ],
      }));
      setShowMembers(true);
    }




  };

  const handleMemberChange = (index, field, value) => {
    // debugger
    const updatedMembers = [...templeBookingObj.BookingPersonDetails];
    updatedMembers[index][field] = value;

    setTempleBookingObj((prev) => ({
      ...prev,
      BookingPersonDetails: updatedMembers,
    }));
  };
  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
    setShowModal(true)
  }

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  console.log('templeBookingObj', templeBookingObj)
  return (
    <div style={{ background: "#F1F6F7", paddingTop: "30px" }}>
      {/* Step Indicator */}
      <div className="stepper-wrapper">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`stepper-item ${index < currentStep
              ? "completed"
              : index === currentStep
                ? "active"
                : ""
              }`}
          >
            <div className="step-counter">{index + 1}</div>
            <div className="step-name" style={{ fontSize: "small" }}>
              {step}
            </div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div
        className="step-content"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px 70px",
          background: "#F1F6F7",
        }}
      >
        {currentStep === 0 && (
          <>
            <div
              style={{
                background: "white",
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                marginBottom: "20px",
              }}
            >
              <div className="row">
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                    Date
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <DatePicker
                    id="bookingDate"
                    value={templeBookingObj?.TRB_DATE || ""}
                    minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                    clearIcon={null}
                    onChange={handleToDateChange}
                    format="dd/MM/yyyy"
                  />
                  {error && !templeBookingObj.TRB_DATE && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                    Time
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    options={timeSlotOption}
                    value={
                      timeSlotOption.find(
                        (option) => option.value === templeBookingObj.TTS_ID
                      ) || null
                    }
                    onChange={handleTimeSlotChange}
                    placeholder="Select Time Slot"
                    styles={customSelectStyles}
                    isClearable
                  />

                  {error && !templeBookingObj.TTS_ID && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>

                {/* <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="REFERAN_CODE" style={{ textAlign: "left" }}>
                    Referral Code

                  </label>
                  <input
                    id="REFERAN_CODE"
                    maxLength={10}
                    type="text"
                    className="custom-form-control"
                    placeholder="Enter Contact no."
                    value={templeBookingObj.REFERAN_CODE}
                    onChange={(e) => {
                      const value = e.target.value;
                      let FormattedNumber = value.replace(/[^0-9]/g, "");


                      FormattedNumber = FormattedNumber.replace(/^[0-5]/, "");
                      setTempleBookingObj((prev) => ({
                        ...prev,
                        REFERAN_CODE: FormattedNumber,
                      }));
                    }}
                  />

                </div> */}

                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="NameUser" style={{ textAlign: "left" }}>
                    Name
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="NameUser"
                    type="text"
                    className="custom-form-control"
                    maxLength={70}
                    value={templeBookingObj.personName || ""}
                    onChange={(e) => {
                      // handleAddMembers(false)
                      let inputVal = e.target.value.trimStart();
                      // handleMemberChange(0, "Name", inputVal)
                      const updatedValue = inputVal.replace(/[^a-zA-Z\s]/g, ""); // Allows only characters and spaces
                      setTempleBookingObj((prev) => {
                        const updatedBookingDetails = [...prev.BookingPersonDetails];

                        if (updatedBookingDetails.length > 0) {
                          updatedBookingDetails[0] = {
                            ...updatedBookingDetails[0],
                            Name: updatedValue, // 👈 update only Name
                          };
                        }

                        return {
                          ...prev,
                          personName: updatedValue,
                          BookingPersonDetails: updatedBookingDetails,
                        };
                      });

                    }}
                    placeholder="Enter Name"
                  />
                  {error && !templeBookingObj.personName && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>

                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="address" style={{ textAlign: "left" }}>
                    Address
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <textarea
                    id="address"
                    className="custom-form-control"
                    value={templeBookingObj.address || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.trimStart();
                      setTempleBookingObj((prev) => ({
                        ...prev,
                        address: inputVal,
                      }));
                    }}
                    placeholder="Enter Address"
                  />
                  {error && !templeBookingObj.address && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="state" style={{ textAlign: "left" }}>
                    Contact Number
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="state"
                    maxLength={10}
                    type="text"
                    className="custom-form-control"
                    placeholder="Enter Contact Number"
                    value={templeBookingObj.contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      let FormattedNumber = value.replace(/[^0-9]/g, ""); // Allows only numbers

                      // Apply regex to ensure the first digit is between 6 and 9
                      FormattedNumber = FormattedNumber.replace(/^[0-5]/, "");
                      setTempleBookingObj((prev) => ({
                        ...prev,
                        contactNumber: FormattedNumber,
                      }));
                    }}
                  />
                  {error && !templeBookingObj.contactNumber ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : error && ((templeBookingObj.contactNumber !== null && templeBookingObj.contactNumber !== undefined && templeBookingObj.contactNumber !== '') && templeBookingObj.contactNumber?.length !== 10) ?
                    <span style={{ color: "red", fontSize: "small" }}>
                      Contact Number should be 10 digit
                    </span> : ''
                  }
                </div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="IdProof" style={{ textAlign: "left" }}>
                    Select Id Proof
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={SelectIdProof}
                    onChange={handleIdProofChange}
                    value={SelectIdProof.find(
                      (item) => item.value === selectedIdProof
                    )}
                    placeholder="Select
                    styles={customSelectStyles} Id Proof"
                  />
                  {error &&
                    (selectedIdProof === null ||
                      selectedIdProof === undefined ||
                      selectedIdProof === "") ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                {/* Conditional Input Field */}
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  {selectedIdProof === "Pan Card" && (
                    <>
                      <label htmlFor="panCard" style={{ textAlign: "left" }}>
                        Enter PAN Card Number{" "}
                        <span style={{ color: "red", fontSize: "small" }}>
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        maxLength={10}
                        className="custom-form-control"
                        placeholder="Enter PAN Card Number"
                        value={templeBookingObj.ID_PROOF_NO || ""}
                        onChange={(e) => {
                          let InputValue = e.target.value;

                          // Prevent the first character from being a space
                          if (InputValue.startsWith(" ")) {
                            InputValue = InputValue.trimStart(); // Remove leading space
                          }
                          const formatedNumber = InputValue.toUpperCase();
                          setTempleBookingObj((prev) => ({
                            ...prev,
                            ID_PROOF_NO: formatedNumber,
                          }));
                        }}
                      />
                      {error &&
                        (templeBookingObj.ID_PROOF_NO === null ||
                          templeBookingObj.ID_PROOF_NO === undefined ||
                          templeBookingObj.ID_PROOF_NO === "") ? (
                        <span style={{ color: "red", fontSize: "small" }}>
                          {ERROR_MESSAGES}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  {selectedIdProof === "Aadhaar Card" && (
                    <>
                      <label htmlFor="adharCard" style={{ textAlign: "left" }}>
                        Enter Aadhaar Number{" "}
                        <span style={{ color: "red", fontSize: "small" }}>
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        maxLength={12}
                        className="custom-form-control"
                        placeholder="Enter Aadhaar Number"
                        value={templeBookingObj.ID_PROOF_NO || ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          let FormattedNumber = value.replace(/[^0-9]/g, "");
                          setTempleBookingObj((prev) => ({
                            ...prev,
                            ID_PROOF_NO: FormattedNumber,
                          }));
                        }}
                      />
                      {error &&
                        (templeBookingObj.ID_PROOF_NO === null ||
                          templeBookingObj.ID_PROOF_NO === undefined ||
                          templeBookingObj.ID_PROOF_NO === "") ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "small",
                            fontSize: "small",
                          }}
                        >
                          {ERROR_MESSAGES}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>

                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="noOfSeats" style={{ textAlign: "left" }}>
                    Age
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="noOfSeats"
                    type="text"
                    maxLength={2}
                    className="custom-form-control"
                    value={templeBookingObj.AGE || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                      // handleMemberChange(
                      //   1,
                      //   "Age",
                      //   inputVal
                      // )
                      setTempleBookingObj((prev) => {
                        const updatedBookingDetails = [...prev.BookingPersonDetails];

                        if (updatedBookingDetails.length > 0) {
                          updatedBookingDetails[0] = {
                            ...updatedBookingDetails[0],
                            Age: inputVal, // 👈 update only Name
                          };
                        }

                        return {
                          ...prev,
                          AGE: inputVal,
                          BookingPersonDetails: updatedBookingDetails,
                        };
                      });


                    }}
                    placeholder="Enter Age"
                  />
                  {error && !templeBookingObj.AGE && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                    Gender
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={genderOptions}
                    placeholder="Select Gender"
                    isClearable
                    value={genderOptions.find(
                      (option) => option.value === templeBookingObj.GENDERID
                    )}
                    onChange={handleGenderChange}
                  />

                  {error &&
                    (templeBookingObj.GENDERID === null ||
                      templeBookingObj.GENDERID === undefined ||
                      templeBookingObj.GENDERID === "") ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                  <label htmlFor="noOfSeats" style={{ textAlign: "left" }}>
                    No of Seats
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="noOfSeats"
                    type="text"
                    maxLength={1}
                    className="custom-form-control"
                    value={templeBookingObj.NO_SEATS || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                      if (inputVal < 4) {
                        setTempleBookingObj((prev) => ({
                          ...prev,
                          NO_SEATS: inputVal,
                          BookingPersonDetails: [], // Reset members if seats change
                        }));
                      }

                      setShowMembers(false); // Reset members input if seats change
                    }}
                    placeholder="Enter No of Seats"
                  />
                  {error && !templeBookingObj.NO_SEATS ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : error && templeBookingObj.NO_SEATS <= 0 ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      Please enter valid number of seats.
                    </span>
                  ) : (error && (
                    !templeBookingObj.BookingPersonDetails ||
                    (Number(templeBookingObj.NO_SEATS) > 1 && templeBookingObj.BookingPersonDetails.length !== Number(templeBookingObj.NO_SEATS))
                  )) ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      Please Add Visitor Details
                    </span>
                  ) : ''}
                </div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column"></div>
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column"></div>
                {Number(templeBookingObj.NO_SEATS) > 1 && Number(templeBookingObj.NO_SEATS) !== templeBookingObj?.BookingPersonDetails?.length && (
                  <div className="row justify-content-center">
                    <div className="col-md-3 text-center">
                      <button
                        className="Normal-app-btn"
                        style={{ padding: "5px 16px", fontSize: "15px" }}
                        onClick={handleAddMembers}
                      >
                        Add Visitors
                      </button>
                    </div>
                  </div>
                )}

                {showMembers && (
                  <div className="row justify-content-center mt-3">
                    {templeBookingObj.BookingPersonDetails.map(
                      (member, index) => (
                        <div key={index} className="col-md-9 d-flex gap-2 mb-2">
                          {/* Name Input */}
                          <div style={{ width: "100%" }}>
                            <input
                              type="text"
                              maxLength={25}
                              className="custom-form-control"
                              placeholder={`Member ${index + 1} Name`}
                              value={member?.Name}
                              disabled={index === 0}
                              onChange={(e) => {
                                let InputValue = e.target.value;

                                // Prevent the first character from being a space
                                if (InputValue.startsWith(" ")) {
                                  InputValue = InputValue.trimStart(); // Remove leading space
                                }
                                const updatedValue = InputValue.replace(
                                  /[^a-zA-Z\s]/g,
                                  ""
                                ); // Allows only characters and spaces
                                handleMemberChange(index, "Name", updatedValue);
                              }}
                            />
                            {error && !member?.Name && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>

                          {/* Age Input */}
                          <div style={{ width: "100%" }}>
                            <input
                              type="text"
                              maxLength={2}
                              className="custom-form-control"
                              placeholder="Age"
                              value={member?.Age}
                              disabled={index === 0}
                              onChange={(e) =>
                                handleMemberChange(
                                  index,
                                  "Age",
                                  e.target.value.replace(/\D/g, "")
                                )
                              }
                            />
                            {error && !member?.Age && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>

                          {/* Gender Dropdown */}
                          <div style={{ width: "100%" }}>
                            <Select
                              styles={customSelectStyles}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              options={genderOptions}
                              placeholder="Select Gender"
                              isClearable
                              value={genderOptions.find(
                                (option) => option.value === member.Gender
                              )}
                              isDisabled={index === 0}
                              onChange={(selectedOption) =>
                                handleMemberChange(
                                  index,
                                  "Gender",
                                  selectedOption ? selectedOption.value : null
                                )
                              }

                            />
                            {error && !member.Gender && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column"></div>
              </div>
            </div>
          </>
        )}
        {currentStep === 1 && (
          <div className="container py-3">
            <div className="row">
              {/* Image Section */}
              <div className="col-md-8">
                <div className="card p-3 shadow-sm d-flex flex-row align-items-center gap-4">
                  <img
                    src={location?.state?.TR_IMAGE || placeholderImg}
                    className="img-fluid "
                    style={{
                      width: "280px",
                      height: "180px",
                      objectFit: "cover",
                    }}
                  />

                  <div>
                    <h5 className="fw-bold ">{location?.state?.TR_NAME}</h5>
                    <hr />
                    <p className="mb-1">
                      <strong>Booking Name :</strong>{" "}
                      {templeBookingObj.personName || "N/A"}
                    </p>
                    {/* <p className="mb-1"><strong>Age:</strong> {templeBookingObj.AGE || "N/A"}</p> */}
                    <p className="mb-1">
                      <strong>Contact Number :</strong> {templeBookingObj.contactNumber || "N/A"}
                    </p>
                    <p className="mb-0">
                      <strong>No. of Seats:</strong> {templeBookingObj.NO_SEATS || "N/A"}

                      <table className="table table-bordered mt-2 " style={{ fontSize: '14PX' }} >
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Visitor's Name</th>
                            <th>Age</th>
                            <th>Gender</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td>{1}</td>
                            <td>{templeBookingObj?.personName}</td>
                            <td>{templeBookingObj?.AGE}</td>
                            <td>{templeBookingObj?.GENDERID}</td>
                          </tr> */}
                          {templeBookingObj?.BookingPersonDetails?.map((value, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{value?.Name}</td>
                              <td>{value?.Age}</td>
                              <td>{value?.Gender}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </p>

                  </div>
                </div>
              </div>

              {/* Details Section */}
              <div className="col-md-4">
                <div className=" booking-details-right">
                  <div className="price-summary">

                    <ul>
                      <li>
                        {appliedCoupon?.isApplied ? (
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span>Applied Coupon</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.CouponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, CouponCode: null,
                                  isApplied: false,
                                  CoupenAmount: 0,
                                  walletAmount: 0
                                }))
                              }}
                              style={{
                                // border: '1px dotted #333',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              Remove

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div
                            onClick={() => setShowModal(true)}
                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>View Coupons & Offers</span>

                            </div>
                            <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                          </div>
                        )}

                      </li>
                      {walletAmount !== 0 && (
                        <li style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              // display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              // cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '16px', cursor: 'pointer', width: '100%' }}>
                                <input
                                  type="checkbox"
                                  checked={isWalletApplied}
                                  onChange={(e) => {
                                    setAppliedCoupon((PREV) => ({
                                      ...PREV, CouponCode: null,
                                      isApplied: false
                                    }))
                                    setIsWalletApplied(e.target.checked)
                                  }
                                  }

                                  style={{ cursor: 'pointer' }}
                                />
                                Available wallet amount (₹) {walletAmount}

                              </label>

                            </div>
                            {/* <div className="d-flex justify-content-center">

                                <small>(Upto 50% can be applied)</small>
                              </div> */}
                            {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                          </div>

                        </li>
                      )}


                      <hr></hr>
                      <li>
                        <span>
                          Price ( ₹ {location?.state?.DARSHAN_PRICE}/Head)

                        </span>
                        <span>
                          {formatToIndianCurrency(
                            Math.round(totals?.totalPrice)
                          )}
                        </span>
                      </li>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Wallet Amount (₹)

                          </span>
                          <span>
                            {appliedCoupon?.walletAmount}
                          </span>
                        </li>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Coupon  Amount (₹)

                          </span>
                          <span>
                            {couponAmount}
                          </span>
                        </li>
                      ) : ''}

                      {/* <hr></hr> */}
                      {/* productBookingData.needSamagri === "yes" */}



                      <li>
                        <span>Convenience Fee (₹):</span>
                        <span>
                          {Math.round(totals?.totalConvienceFee)}

                        </span>
                      </li>
                      <hr />


                      <li>
                        <span>Grand Total (₹):</span>
                        <span>
                          {" "}
                          {formatToIndianCurrency(Math.round(totalPrice1))}
                        </span>
                      </li>
                    </ul>
                    <div className="mt-3 d-flex justify-content-end gap-2">

                      {/* <button
                            style={{ padding: "5px 5px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={handleCODClicked}
                          >
                            Cash On Delivery
                          </button> */}


                      <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handleRazorpayPayment}
                      >
                        Pay Now
                      </button>
                      {/* <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handlePhonepayPayment}
                      >
                        Phone Pay
                      </button> */}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="container py-3">
            <div className="row">
              {/* Image Section */}
              <div className="col-md-6">
                <div className="card p-3 shadow-sm d-flex flex-row align-items-center gap-3">
                  <img
                    src={location?.state?.TR_IMAGE || placeholderImg}
                    className="img-fluid rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  {/* <h5 className="fw-bold text-center mt-3">
                    {location?.state?.TR_NAME}
                  </h5> */}
                  <div>
                    <h5 className="fw-bold m-0">{location?.state?.TR_NAME}</h5>
                    <p className="mb-1">
                      <strong>Booking Name:</strong>{" "}
                      {templeBookingObj.personName || "N/A"}
                    </p>
                    {/* <p className="mb-1"><strong>Age:</strong> {templeBookingObj.AGE || "N/A"}</p> */}
                    <p className="mb-1">
                      <strong>Contact Number:</strong> {templeBookingObj.contactNumber || "N/A"}
                    </p>
                    <p className="mb-0">
                      <strong>No. of Seats:</strong>{" "}
                      {templeBookingObj.NO_SEATS || "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Details Section */}
              <div className="col-md-6">
                <div className="card p-3 shadow-sm">
                  <h5 className="fw-bold mb-3">Booking Details</h5>
                  <div className="row">
                    <div className="col-6">
                      <strong>Price </strong>({templeBookingObj?.NO_SEATS} × ₹
                      {location?.state?.DARSHAN_PRICE}) :
                    </div>

                    <div className="col-6 text-end">₹{totals?.totalPrice}</div>

                    <div className="col-6">
                      <strong>Convenience Fee:</strong>
                    </div>

                    <div className="col-6 text-end">
                      ₹{totals?.totalConvienceFee}
                    </div>

                    {/* Horizontal Line */}
                    <div className="col-12">
                      <hr />
                    </div>

                    {/* <div className="col-6">
                      <strong>Total :</strong>
                    </div> */}
                    {/* <div className="col-6 text-end fw-bold">
                      ₹ {totals?.totalPrice + totals?.totalConvienceFee}
                    </div> */}
                    {/* <div className="col-6">
                      <strong>
                        Tax ({ServiceDiscounts?.darshanBooking}) % :
                      </strong>
                    </div> */}
                    {/* <div className="col-6 text-end">
                      ₹ {Number(DynamicTax).toFixed(2)}
                    </div> */}
                    {/* Horizontal Line */}
                    {/* <div className="col-12">
                      <hr />
                    </div> */}

                    <div className="col-6">
                      <strong>Grand Total:</strong>
                    </div>
                    <div className="col-6 text-end fw-bold">
                      ₹ {totalPrice1}
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="d-flex justify-content-end mt-3">
                    {/* <button

                      className="btn text-white  mx-1"
                      style={{ backgroundColor: "#8f3246", color: "black" }}
                      onClick={handleCODClicked}
                    >
                      Cash On Delivery
                    </button> */}
                    <button
                      className="Normal-app-btn mx-2"
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      onClick={handleRazorpayPayment}
                    >
                      Pay
                    </button>
                    {/* <button
                      className="Normal-app-btn"
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      onClick={handlePhonePayPayment}
                    >
                      Phone Pay
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div>
            <div className="carousel-inner" role="listbox">
              <div className="item carousel-item-four active">
                <div className="">
                  <div className="row">
                    <div className="carousel slide carousel-slider">
                      <div className="carousel-position-four">
                        <div className="carousel-inner">
                          <div
                            className="banner-breadcrumb"
                            style={{
                              // backgroundImage: `url(${StupaImg})`,
                              width: "100%",
                              // height: "100px",
                            }}

                          // style={{ backgroundImage: `url(${AboutImg})` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="error-404">
              <div>
                <img
                  src={placeholderImg}
                  alt="404"
                  className="error-404__image"
                  height={100}
                />
              </div>

              <h3 className="error-404__text">Thank you for your order! </h3>

              <div className="error-404__btns">
                {" "}
                <button
                  className="Normal-app-btn"
                  style={{ padding: "5px 16px", fontSize: "14px" }}
                  onClick={() => navigate("/my-order-darshan-Booking")}
                >
                  My Orders
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {currentStep !== 1 && currentStep !== 2 ? (
        <div

          style={{ display: 'flex', marginRight: "50px", paddingBottom: "20px", justifyContent: 'flex-end' }}
        >
          {/* {currentStep !== 0 && (
            <button
              onClick={prevStep}
              disabled={currentStep === 0}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Previous
            </button>
          )} */}

          <button
            onClick={
              currentStep === 0
                ? HandleTempleDarshanBookingBtnClicked
                : currentStep === 1
                  ? handlePanditSelectionNext
                  : ""
            }
            disabled={currentStep === steps.length - 1}
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
          >
            Next
          </button>
        </div>
      ) : currentStep === 1 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "20px" }}
        >
          <button
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
            onClick={prevStep}
          >
            Previous
          </button>
        </div>
      ) : (
        ""
      )}
      <TempleCodModal
        show={showCODModal}
        onHide={() => setShowCODModal(false)}
        onConfirm={handleRazorpayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </div>
  );
};

export default TempleBookingForm;
